import { VideoPlaylist } from '@/components/VideoPlaylist';
import { VideoReels } from './VideoReels';

export const StandaloneVideoReels: typeof VideoPlaylist = (props) => <VideoReels {...props} />;
